import { Timestamp } from '@angular/fire/firestore';
import { NotesType } from './lesson.school.model';

export interface GradeLesson {
  id?: string;
  lessonId?: string;
  lessonName?: string;

  gradeId?: string;

  tags?: string[];

  notesId?: string;
  notesUrl?: string;
  notesType?: NotesType;

  teacherNotes?: TeacherNotes[];

  groupId?: string;
  academicYear?: number;

  lessonStatus?: GradeLessonStatus;
  publishBy?: Timestamp;

  createdBy?: string;
  createdById?: string;
  memberPhotoUrl?: string;

  created?: Timestamp;
  modified?: Timestamp;
}

export interface TeacherNotes {
  id: string;
  name: string;
  type: NotesType;
  url: string;
  createdBy?: string;
  createdById?: string;
  created?: Timestamp;
  modified?: Timestamp;
}

export enum GradeLessonStatus {
  open = 'open',
  closed = 'closed',
  archived = 'archived',
}
